webpackJsonp([129794500721417],{

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _meta = __webpack_require__(16);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var metadata = {
	  title: 'Me connaitre | Psychologue clinicienne les arceaux | Morgane Laroche',
	  description: 'Ma formation de psychologue. Spécialisations, approches et méthodes. Quelques axes de travail. psychologue jardin des plantes'
	};
	
	var MeConnaitre = function MeConnaitre() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container container--page' },
	    _react2.default.createElement(_meta2.default, { title: metadata.title, description: metadata.description }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container__block' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'container__block-title container__block-title--nomarge' },
	        'ME CONNAITRE'
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'container__block-subtitle' },
	        'Ma formation'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'Dipl\xF4m\xE9e d\u2019un Master 2 en Psychopathologie et Psychologie clinique\xA0',
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'container__block-link',
	            href: 'http://www.univ-lyon2.fr/',
	            target: '_blank'
	          },
	          '(Universit\xE9 Lumi\xE8re de Lyon II)'
	        ),
	        ', je me suis d\u2019abord familiaris\xE9e \xE0 l\u2019approche int\xE9grative au cours de mes trois ann\xE9es de Licence r\xE9alis\xE9es \xE0 la\xA0',
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'container__block-link',
	            href: 'https://www.u-bourgogne.fr/',
	            target: '_blank'
	          },
	          'facult\xE9 de Bourgogne'
	        ),
	        '. Cette approche propose de s\u2019appuyer sur diff\xE9rentes m\xE9thodes, courants de pens\xE9es et outils en mettant l\u2019accent sur leur compl\xE9mentarit\xE9. Elle consid\xE8re qu\u2019aucune technique, \xE0 elle seule, n\u2019est suffisamment compl\xE8te et adapt\xE9e et qu\u2019il est pr\xE9f\xE9rable de les unifier afin de pouvoir r\xE9pondre \xE0 chaque individu et aux probl\xE9matiques qui l\u2019animent.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe u-mb' },
	        'Par la suite, j\u2019ai souhait\xE9 m\u2019int\xE9resser davantage \xE0\xA0',
	        _react2.default.createElement(
	          'span',
	          { className: 'u-bold' },
	          'l\'approche psychanalytique'
	        ),
	        ' qui m\'a particuli\xE8rement fait \xE9cho, socle \xE0 partir duquel ma pratique s\'inspire, en laissant libre court \xE0 la parole, aux choses que l\u2019on ne dit pas au premier abord mais qui s\u2019entendent au-del\xE0 des mots. En cela, elle suppose une \xE9coute des enjeux et processus inconscients, du r\xEAve, des \xE9motions que l\'on retient ou au contraire, qui nous d\xE9bordent.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'container__block-subtitle' },
	        'Mon parcours'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'Mon parcours a essentiellement d\xE9but\xE9 par des exp\xE9riences professionnelles dans le champ de la psychiatrie (en h\xF4pital psychiatrique, en Centre m\xE9dico-psychologique et en foyer de vie accueillant des individus en situation de handicap psychique) aupr\xE8s de patients adultes mais \xE9galement d\'enfants et adolescents. En ces diff\xE9rents lieux, je me suis particuli\xE8rement int\xE9ress\xE9e aux dimensions suivantes :'
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'container__content-list u-mb' },
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'u-bold' },
	            'La dimension psychosomatique :'
	          ),
	          '\xA0elle envisage le corps comme une sc\xE8ne du psychisme. Quand la parole ne suffit plus ou semble faire impasse pour un individu, c\u2019est parfois \xE0 travers le corps et ses maux, que nos difficult\xE9s, nos angoisses s\u2019expriment. En s\u2019y int\xE9ressant de plus pr\xE8s, les pr\xE9mices d\u2019une parole, d\'une souffrance jusqu\u2019ici indicibles vont pouvoir na\xEEtre.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'u-bold' },
	            'La dimension inter/transculturelle :'
	          ),
	          '\xA0 elle consiste \xE0 entendre la parole de l\u2019autre en tant qu\u2019individu issu d\u2019une culture sp\xE9cifique et de son appartenance \xE0 un environnement social et familial. Elle participe \xE0 la construction de l\u2019identit\xE9 (histoire familiale, h\xE9ritage culturel, transmission g\xE9n\xE9alogique), donc au d\xE9veloppement du sujet. Elle peut apporter un \xE9clairage face \xE0 des probl\xE9matiques dont les n\u0153uds sont parfois difficiles \xE0 d\xE9m\xEAler.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'u-bold' },
	            'Les probl\xE9matiques addictives :'
	          ),
	          '\xA0elles sont autant de tentatives pour \xAB faire face \xBB \xE0 des \xE9preuves douloureuses de s\xE9parations, de pertes, de deuils (pour ne citer que celles-ci) qui peuvent parfois sembler ind\xE9passables pour un individu. Cet espace, dans lequel je vous accueille, invite \xE0 lib\xE9rer la parole afin d\u2019acc\xE9der \xE0 un travail de mise en mots de ces v\xE9cus douloureux et des sentiments qui les accompagnent.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'Par la suite, je me suis dirig\xE9e vers le domaine de la g\xE9riatrie. De l\'h\xF4pital g\xE9riatrique \xE0 l\'EHPAD, cette pratique m\'a invit\xE9e \xE0 consid\xE9rer tant la dimension psychique individuelle des patients/r\xE9sidents accueillis que celle de leurs proches aidants, mais \xE9galement, des \xE9quipes d\xE9di\xE9es \xE0 leur accompagnement. Cela m\'a sensibilis\xE9e \xE0 l\'\xE9coute et l\'accompagnement des familles et les retentissements dans l\'accompagnement de leur proche. Cette exp\xE9rience a notamment orient\xE9 ma pratique vers des dispositifs groupaux \xE0 travers l\'animation de groupes de paroles ou d\'instances de r\xE9flexion telles que les Commission \xC9thique et Bientraitance.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'Ces diff\xE9rentes exp\xE9riences en institution ont \xE9t\xE9 autant de r\xE9flexion sur la sp\xE9cificit\xE9 de chaque population accueillie, allant du petit au grand \xE2ge, qu\'une r\xE9flexion relative aux mouvements psychiques de groupes, leurs m\xE9canismes et leurs enjeux.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'Actuellement, j\'accueille des patients adultes en consultations individuelles. Je ne pratique ni la th\xE9rapie familiale ni la th\xE9rapie de couple.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'Un travail r\xE9gulier de supervision individuelle, de formation (lectures, conf\xE9rences, etc) vient encadrer et enrichir ma pratique.'
	      )
	    )
	  );
	};
	exports.default = MeConnaitre;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-me-connaitre-js-407df2b5a73174905dac.js